import React from "react";
import { ITeamMatchByMonths } from "../types/ITimeline";
import LabelNumber from "../styled-components/LabelNumber";
import LabelText from "../ui/LabelText";
import MatchDetail from "./MatchDetail";

interface MonthMatchesProps {
  monthData: ITeamMatchByMonths;
  selectedMatch: number;
  onMatchSelect: (matchId: number) => void;
}

const MonthMatches: React.FC<MonthMatchesProps> = ({ monthData, selectedMatch, onMatchSelect }) => {
  return (
    <div>
      <div className="match-year-month">
        <LabelNumber className="descriptive-large-text">{monthData.year}</LabelNumber>
        <LabelText className="player-given-name">{monthData.month}</LabelText>
      </div>
      <div className="match-detail-wrapper">
        {monthData.matchTeams.map((match, index) => (
          <MatchDetail
            key={match.matchId}
            match={match}
            isSelected={selectedMatch === match.matchId}
            onMatchSelect={(matchId) => onMatchSelect(matchId)}
          />
        ))}
      </div>
    </div>
  );
};

export default MonthMatches;
